
$('document').ready(function(){
  function showCoords() {    
    var headerEl = $(".getCords .shogun-heading-component");
    headerEl.find('.blog_meta').remove();
    $('body.article .blog_meta').css('position', 'static').addClass('showDate').insertBefore(headerEl.find('h2'));
  }
  
  if($('body').hasClass('article')){
    showCoords(); 
  }
  
  /* ==================================Faq Page================================== */
  $(document).on('click', '.faqTabs', function() {
    var idVal = $(this).attr('href');
    if($(idVal).length > 0) {
      var topVal = $(idVal).offset().top;
      if($(window).width() > 767) {
        var scrollVal = topVal - 100;
      }
      else {
        var scrollVal = topVal - 50;
      }
      
      $('html,body').animate({'scrollTop':scrollVal},300);
    }
  });
  $(document).on('click', '.faqs dt', function() {
    $(this).next().slideToggle(300);
    $(this).find('.fa').toggleClass('fa-angle-down').toggleClass('fa-angle-right');
  });
  
  $(document).on('click','.ft-open', function() {
    $(this).closest('.faqs').find('dd').slideDown(300);
    $(this).closest('.faqs').find('dt .fa').removeClass('fa-angle-right').addClass('fa-angle-down');
  });
  
  $(document).on('click','.ft-close', function() {
    $(this).closest('.faqs').find('dd').slideUp(300);
    $(this).closest('.faqs').find('dt .fa').removeClass('fa-angle-down').addClass('fa-angle-right');
  });

  
  // variables
  var win = $(window);
  if(win.width() > 798) {
    var top = 100;
  }
  else {
    var top = 60;
  }
  function responsiveSticky(topPosition,floatingDiv,absPosition) {
    if (window.matchMedia('(min-width: 768px)').matches) {
      if ((win.scrollTop() > topPosition) && (win.scrollTop() < absPosition)) {
        floatingDiv.addClass('stickySection');
        floatingDiv.removeClass('absoluteSection');

      } else if ((win.scrollTop() > topPosition) && (win.scrollTop() > absPosition)) {
        floatingDiv.removeClass('stickySection');
        floatingDiv.addClass('absoluteSection');

      } else {
        floatingDiv.removeClass('stickySection');
        floatingDiv.removeClass('absoluteSection');
      }
    }
  }
  var topPosition, floatingDivHeight, footerFromTop, absPosition, floatingDiv;
  function faqSticky() {
    if($('body').find('div').hasClass('faqAccordionWrap')) {
      topPosition = $('.linkTriggerWrap').offset().top - top;
      floatingDivHeight = $('.linkTriggerWrap').outerHeight();
      footerFromTop = $('.faqAccordionWrap').offset().top + $('.faqAccordionWrap').outerHeight();
      absPosition = footerFromTop - floatingDivHeight - 60;
      floatingDiv = $('.linkTriggerWrap');
      responsiveSticky(topPosition,floatingDiv,absPosition);
    }

  }
  faqSticky();
  win.resize(function() {
    $('.linkTriggerWrap').removeClass('stickySection absoluteSection');
    faqSticky();
  });
  
  win.scroll(function() {
    if($('body').find('div').hasClass('faqAccordionWrap')) {
      responsiveSticky(topPosition,floatingDiv,absPosition);
    }
  });
  
  $(document).on('click', '.pt-action', function() {
    var _this = $(this);
    var index = _this.closest('li').index();
    _this.closest('li').addClass('active').siblings('li').removeClass('active');
    _this.closest('.pt-header').siblings('.pt-body').find('li').eq(index).show().siblings('li').hide();
  });
  
  $(document).on('click', '.pdp-metaBtn', function() {
    var $this = $(this);
    var containerHeight = $this.siblings('.pdp-metaText').find('.reduceheight .contentWrapper').outerHeight();
    console.log('container', containerHeight);
    $this.addClass('hide').siblings('.pdp-metaBtn').removeClass('hide');
    if($this.is('.pdp-metaMore')) 
    {
      $this.siblings('.pdp-metaText').find('.reduceheight').animate({'max-height': containerHeight},300);
    }
    else {
      $this.siblings('.pdp-metaText').find('.reduceheight').animate({'max-height': '90px'},300);
    }
  });
  
  if($('body').hasClass('product')) {
    if($('body').find('div').hasClass('fs-wrapper')) {
      $('.fs-wrapper').slick({
        dots: true,
        appendDots: '.dots',
        arrows: true,
        prevArrow: true,
        prevArrow:'<span class="fs_arrow fs_PrevArrow"></span>',
        nextArrow: true,
        nextArrow:'<span class="fs_arrow fs_NextArrow"></span>',
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false,
            prevArrow: false,
            nextArrow: false
          }
        }
      ]
      });
    }
    
    if($('body').find('div').hasClass('product-testimonial')) {
      $('.pt-wrap').slick({
        dots: true,
        appendDots: '.testimonial-dots',
        arrows: true,
        prevArrow: true,
        prevArrow:'<span class="fs_arrow fs_PrevArrow"></span>',
        nextArrow: true,
        nextArrow:'<span class="fs_arrow fs_NextArrow"></span>',
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              prevArrow: false,
              nextArrow: false
            }
          }
        ]
      });
    }
    
   
   
  
    
  }
  
  
  if($('body').hasClass('product')) {
    $(document).on('click', '.productBtn', function() {
      $('.shopify-product-form').removeClass('activeForm');
      $(this).closest('.shopify-product-form').addClass('activeForm');
      $('.tc-popup').css('display','flex');
      $('.tc-continue').attr('disabled',true);
    });
  }
  
  if($('body').hasClass('product') || $('body').hasClass('collection') || $('body').hasClass('search') ) {    

    $(document).on('click', '.tc-close', function() {
      console.log('hiiii product')
      $('.tc-popup').css('display','none');
      $('.tc-continue').attr('disabled',true);
      $('#tc-check').prop('checked', false);
    });

    $(document).on('change','#tc-check', function() {
      var checkVal = $(this).prop('checked');
      if(checkVal == true) {
        $('.tc-continue').removeAttr('disabled');
      }
      else {
        $('.tc-continue').attr('disabled',true);
      }
    });
    
     $(document).on('click', '.tc-continue', function(){
    	$(this).attr('disabled',true);
        $(this).parents('.shopify-product-form').find('.tc-popup #tc-check').prop('checked', false); 
  })
    
    
  }
  
  
  if($('body').hasClass('collection') || $('body').hasClass('search')){
    $(document).on('click', '.productBtn', function() {
      $('.shopify-product-form').removeClass('activeForm');
      $(this).closest('.shopify-product-form').addClass('activeForm');
      $(this).parents('.shopify-product-form').find('.tc-popup').css('display','flex');
       $(this).parents('.shopify-product-form').find('.tc-popup #tc-check').prop('checked', false);
       $(this).parents('.shopify-product-form').find('.tc-popup .tc-continue').attr('disabled',true);

    })

  }
  
 
  /*
  function gridHeight() {
    var infoHeightArr = [];
    $('#bc-sf-filter-products .column').each(function() {
      var infoHeight = $(this).find('.product-info__caption').outerHeight();
      infoHeightArr.push(infoHeight);
    });
    var maxHeight = Math.max.apply(null,infoHeightArr);
    $('#bc-sf-filter-products .column .product-info__caption').outerHeight(maxHeight);
  }
  
  if($('body').hasClass('collection')) {
    gridHeight();
  }
  
  $(window).resize(function() {
    if($('body').hasClass('collection')) {
      $('#bc-sf-filter-products .column .product-info__caption').outerHeight('auto');
      gridHeight();
    }
  });
  */
  
  $(document).on('click', '.searchBtn', function() {
    $(this).siblings('.search_form').fadeIn(300);
    $(this).closest('.top_bar').siblings('.custom_dropdown[data-dropdown="search"]').fadeIn(300);
    $('body').addClass('blocked-scroll searchPopUp');
    $('.searchInputWrap input').focus();
  });
  
  $(document).on('click', '.searchClose', function() {
    if($(window).width() > 767) {
      $(this).closest('.search_form').fadeOut(300);
    }
    else {
      $(this).closest('.custom_dropdown').fadeOut(300);
    }    
    $('body').removeClass('blocked-scroll searchPopUp');
  });
  
  
  
	$('.searchSection ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('active');
		$('.tab-content').removeClass('active');

		$(this).addClass('active');
		$("#"+tab_id).addClass('active');
	})
    
    if($('#shopify-section-product-template').length > 0){
    $('#shopify-section-product-template .productPage .shopify-product-form .swatch_options .swatch .swatch-element label').on('click', function(){
      setTimeout(function(){
        var a =$('#shopify-section-product-template .productPage .shopify-product-form .multi_select option:selected').text();
       
        
         $("#shopify-section-product-template .productPage  .notify_form .select select option").removeAttr('selected');
        $("#shopify-section-product-template .productPage  .notify_form .select select option:contains("+a+")").attr('selected', 'selected');
      },0)
    })
    }
  
  
  $('.search_form .searchInputWrap .searchClearInput, .header .rightMenu .searchBtn').on('click', function(){
    $('.search_form .searchInputWrap input').val('');
    $('.searchInputWrap .searchClearInput').removeClass('showClearIcon');
    $('.searchInputWrap input').focus();
  });

 
  
  $(document).on('keyup', '.search_form .searchInputWrap input',function(){
   
     if($(this).val() == ''){
      $('.searchInputWrap .searchClearInput').removeClass('showClearIcon');
    }
    else{
      $('.searchInputWrap .searchClearInput').addClass('showClearIcon');
    }
  })
 
  
  
});


$(document).on('click', '#bc-sf-filter-tree #bc-sf-filter-options-wrapper > div .bc-sf-filter-option-multiple-list li a, #bc-sf-filter-tree #bc-sf-filter-options-wrapper > div .bc-sf-filter-option-single-list li a, .bc-sf-filter-clear, .bc-sf-filter-clear-all',function(){
  if($(window).outerWidth() >= 768){
    if($('body').hasClass('collection') || $('body').hasClass('search')){
      setTimeout(function(){
        getTitleHeight();
      },1500)
      
    }
  }
})

$(window).on("load", function() {
  if($(window).outerWidth() >= 768){
    if($('body').hasClass('collection') || $('body').hasClass('search')){
      getTitleHeight();

    }
  }

});

$(window).on('resize', function(){
  if($(window).outerWidth() >= 768){
    if($('body').hasClass('collection') || $('body').hasClass('search')){
      getTitleHeight();  
    }
  }
  else{
  $('#bc-sf-filter-products > div').find('.product-wrap .product-info__caption .product-details .title').css('min-height', 'auto');  
  }
  calculateBodyOffset();
})

$(function(){
  calculateBodyOffset();
});

function getTitleHeight(){
 var minHeight = 0, i=0, row=1, items=3;  
      $('#bc-sf-filter-products > div').each(function(){
        var a = $(this).find('.product-wrap .product-info__caption .product-details .title').outerHeight();
        if(a > minHeight){
        minHeight = a;
        }
        else{
        minHeight = minHeight;
        }
         $(this).find('.product-wrap .product-info__caption .product-details .title').addClass('row-'+row);
        i++;
        var windowWidth = $(window).outerWidth();
        if(windowWidth >1070){
        items = 3;
        }
        else{
        items = 2;
        }
        
        console.log('he', minHeight);
        if(i==items){
          $('#bc-sf-filter-products > div').find('.product-wrap .product-info__caption .product-details .title.row-'+row).css('min-height', minHeight);  
           minHeight =0;
          i=0;
          row++;
        }
        
      })
  	$('#bc-sf-filter-products > div').find('.product-wrap .product-info__caption .product-details .title.row-'+row).css('min-height', minHeight);  
}

function calculateBodyOffset(){
  var $headerDesktop = $('.header:visible');
  var $headerMob = $('header#header:visible');
  if($headerDesktop.is(':visible')){
    var $headerHeight = $headerDesktop.outerHeight();
  }else{
    var $headerHeight = $headerMob.outerHeight();
  }  
  $('body').css('padding-top', $headerHeight);
}
                                    